/**
** JAVASCRIPTS
** Name: Video btn
********************************************************************************/

document.addEventListener("DOMContentLoaded", () => {
  const videos = document.querySelectorAll(".c-video");

  videos.forEach((video) => {
    const wrapper = video.querySelector(".c-video__wrapper");
    const button = video.querySelector(".c-video__button");
    const figure = video.querySelector(".c-video__figure");
    const videoID = wrapper?.dataset.videoid;

    if (!wrapper || !videoID) return;

    const createIframe = () => {
      const iframe = document.createElement('iframe');
      iframe.setAttribute('src', `https://www.youtube-nocookie.com/embed/${videoID}?enablejsapi=1&rel=0&origin=${window.location.origin}`);
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');

      iframe.addEventListener('load', () => {
        iframe.contentWindow?.postMessage(JSON.stringify({
          event: 'command',
          func: 'playVideo',
          args: [],
        }), '*');
      });

      return iframe;
    };

    const launchVideo = () => {
      // Remplace l'iframe YouTube existante, le div Tarteaucitron, ou tout autre contenu dans l'embed
      const target = wrapper.querySelector('iframe[src*="youtube"], .youtube_player, .tac_video_player')
        ?? wrapper.querySelector('.c-figure__embed');

      if (target?.matches('.c-figure__embed')) {
        target.innerHTML = '';
        target.appendChild(createIframe());
      } else if (target) {
        target.replaceWith(createIframe());
      }
    };

    const startVideo = () => {
      if (button) button.remove();
      if (figure) figure.remove();

      video.classList.remove("c-video--notplay");

      const tacManagesYoutube = typeof tarteaucitron !== 'undefined'
        && Array.isArray(tarteaucitron.job)
        && tarteaucitron.job.includes('youtube');

      if (!tacManagesYoutube || tarteaucitron.state?.youtube === true) {
        launchVideo();
      } else {
        const observer = new MutationObserver(() => {
          const tacIframe = wrapper.querySelector('iframe[src*="youtube"]');
          if (!tacIframe) return;
          observer.disconnect();
          tacIframe.replaceWith(createIframe());
        });

        observer.observe(wrapper, { childList: true, subtree: true });
      }
    };

    if (button) button.addEventListener("click", startVideo);
    if (figure) figure.addEventListener("click", startVideo);
  });
});
